import { BASE_URL } from './Config.js';

export class TVAStateService {
  createTVAState = async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva-state/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error('Erreur création État TVA');
      return await response.json();
    } catch (error) { console.error('Error creating TVA state:', error); throw error; }
  };

  getAllTVAStates = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva-state/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement États TVA');
      return await response.json();
    } catch (error) { console.error('Error fetching TVA states:', error); throw error; }
  };

  getTVAStateById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva-state/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement détail État TVA');
      return await response.json();
    } catch (error) { console.error('Error fetching TVA state:', error); throw error; }
  };

  updateTVAState = async (id, data) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva-state/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error('Erreur mise à jour État TVA');
      return await response.json();
    } catch (error) { console.error('Error updating TVA state:', error); throw error; }
  };

  deleteTVAState = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva-state/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur suppression État TVA');
      return true;
    } catch (error) { console.error('Error deleting TVA state:', error); throw error; }
  };

    deleteAllTVAStates = async () => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/tva-state/delete-all`, {
      method: 'DELETE',
      headers: { 
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });
    
    if (!res.ok) {
      throw new Error(await res.text() || 'Erreur lors de la suppression globale');
    }
    
    // 🟢 Gestion robuste (Texte brut ou JSON)
    const rawText = await res.text(); 
    try {
      return JSON.parse(rawText); 
    } catch (e) {
      return { success: true, message: rawText };
    }
  };
}